
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from "@material-ui/core";
import { SwapHoriz } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { useStyles } from "../../styles.jsx";
import { getRestauranteFromStorage, ensureRestauranteLoaded } from '../../services/selectedRestaurante';

const CategoryHeader = ({ categoryName }) => {
    const [restaurante, setRestaurante] = useState({});
    const styles = useStyles(restaurante);
    const history = useHistory();

    useEffect(() => {
        const loadRestaurante = async () => {
            let rest = getRestauranteFromStorage();
            if (!rest) {
                rest = await ensureRestauranteLoaded();
            }

            setRestaurante(rest || {});
            if (rest) localStorage.setItem('restaurante', JSON.stringify(rest));
        };

        loadRestaurante();
    }, []);

    const handleChangeRestaurant = () => {
        history.push('/selecionar-restaurante');
    };

    return (
        <Box style={{ 
            backgroundColor: restaurante.corPrimaria || '#fa5b6d', 
            padding: '24px 36px', 
            position: 'sticky', 
            top: 0, 
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }}>
            <Typography
                component="h2"
                variant="h2"
                className={styles.title}
                style={{ color: 'white', margin: 0 }}
            >
                {categoryName || 'Menu'}
            </Typography>

            <Button
                variant="contained"
                color="secondary"
                startIcon={<SwapHoriz />}
                onClick={handleChangeRestaurant}
                style={{
                    backgroundColor: '#118e16',
                    color: 'white',
                    minWidth: '180px',
                    height: '48px',
                    borderRadius: '24px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1rem',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        backgroundColor: '#0f7a13',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 16px rgba(0,0,0,0.3)',
                    }
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0f7a13';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#118e16';
                    e.target.style.transform = 'translateY(0px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
                }}
            >
                Trocar Restaurante
            </Button>
        </Box>
    );
};

export default CategoryHeader;
